import { getPrice as getProductPrice } from '~/modules/catalog/product/getters/productGetters';

export function getUpsellProductPriceCommand(products): number {

  const evalProductPrice = (p) => {
    const { regular, special } = getProductPrice(p);

    return regular > special && special !== null ? special : regular;
  };

  return products?.reduce((acc, curr) => {
    const quantity = curr?.qty ?? 0;
    return quantity * evalProductPrice(curr) + acc;
  }, 0) ?? 0;
}
